module.exports = __webpack_public_path__ + "img/icon-home.52a9e0e6.svg";